import { Devices } from '@common/constants/shared';
import { useAppDispatch, useAppSelector } from '@common/redux/hooks';
import { appInfoSelector } from '@common/redux/selectors/app';
import { deviceSelectedSelector } from '@common/redux/selectors/devices';
import { setDeviceSelected } from '@common/redux/slice/device';
import { Platform, PrimaryBreakpoint } from 'click-types';
import React, { useCallback, useEffect } from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome5';

const DeviceOptionsDesktopFirst = [
  {
    icon: 'desktop',
    device: Devices.DESKTOP,
  },
  {
    icon: 'tablet-alt',
    device: Devices.TABLET,
  },
  {
    icon: 'mobile-alt',
    device: Devices.IPHONE_PRO,
  },
];

const DeviceOptionsMobileFirst = [
  {
    icon: 'mobile-alt',
    device: Devices.IPHONE_PRO,
  },
  {
    icon: 'tablet-alt',
    device: Devices.TABLET,
  },
  {
    icon: 'desktop',
    device: Devices.DESKTOP,
  },
];

const getDefaultDeviceOptions = (primaryBreakpoint: PrimaryBreakpoint) => {
  switch (primaryBreakpoint) {
    case PrimaryBreakpoint.DESKTOP:
      return Devices.DESKTOP;
    case PrimaryBreakpoint.MOBILE:
    default:
      return Devices.IPHONE_PRO;
  }
};

export const SelectDevice = () => {
  const appData = useAppSelector(appInfoSelector);
  const device = useAppSelector(deviceSelectedSelector);
  const dispatch = useAppDispatch();

  const DeviceOptions =
    appData?.primaryBreakpoint === PrimaryBreakpoint.DESKTOP
      ? DeviceOptionsDesktopFirst
      : DeviceOptionsMobileFirst;

  const changeDevice = useCallback(
    (device: Devices) => {
      dispatch(setDeviceSelected(device));
    },
    [dispatch]
  );

  useEffect(() => {
    const defaultDevice = getDefaultDeviceOptions(
      appData?.primaryBreakpoint || PrimaryBreakpoint.MOBILE
    );
    changeDevice(defaultDevice);
  }, [appData?.primaryBreakpoint]);

  return appData?.platform === Platform.RESPONSIVE ? (
    <View nativeID="device-selector" style={styles.container}>
      <View style={styles.wrapper}>
        {DeviceOptions.map((option) => (
          <TouchableOpacity
            key={option.device}
            onPress={() => changeDevice(option.device)}
            style={[
              styles.optionButton,
              option.device === device && styles.optionButtonActive,
            ]}
          >
            <Icon
              name={option.icon}
              size={18}
              color={option.device === device ? '#ADB6B9' : '#ADB6B9'}
            />
          </TouchableOpacity>
        ))}
      </View>
    </View>
  ) : null;
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 4,
    backgroundColor: 'rgb(242, 245, 247)',
    marginBottom: 24,
  },
  wrapper: {
    backgroundColor: 'white',
    flexDirection: 'row',
    borderRadius: 8,
    padding: 4,
    marginHorizontal: 8,
    shadowColor: '#172F79',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 30,
  },
  optionButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginHorizontal: 2,
    borderRadius: 6,
    backgroundColor: 'transparent',
  },
  optionButtonActive: {
    backgroundColor: 'rgb(242, 245, 247)',
  },
});
